// extracted by mini-css-extract-plugin
module.exports = {"hideOnSmallScreen":"WoPjqqzQQ6Rxb-JXpr6ej"};